export enum UserPermissions {
  ViewNewJobsTab = 'view_new_jobs_tab',
  ViewYourPayField = 'view_your_pay_field',
  ViewPaymentSetupPage = 'view_payment_setup_page',
  ContractorAdmin = 'contractor_admin',
  AssignJobsAssignee = 'Assignee',
  Offers = 'Offers',
  Pricing = 'Pricing',
  None = 'None',
}
